<div class="filtro">
  <mat-form-field class="w30" appearance="outline">
    <mat-label>Filtro</mat-label>
    <mat-select
      id="filtro"
      name="filtro"
      [(ngModel)]="filtroSelecionado"
      (ngModelChange)="optionChanged()"
    >
      <mat-option *ngFor="let filtro of filtros" [value]="filtro.id">{{
        filtro.description
      }}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field *ngIf="!exibirFiltroData" class="w50" appearance="outline">
    <mat-label>Descrição</mat-label>
    <input
      matInput
      id="descricaoFiltro"
      type="text"
      [(ngModel)]="descricao"
      [disabled]="filtroSelecionado === 0"
      (keyup.enter)="filtrar()"
    />
  </mat-form-field>
  <mat-form-field class="w20" appearance="outline" *ngIf="exibirFiltroData">
    <mat-label>Data Inicial</mat-label>
    <input
      id="dataInicial"
      matInput
      [matDatepicker]="picker1"
      [(ngModel)]="dataInicial"
      (input)="formatarData($event)"
    />
    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
    <mat-datepicker #picker1></mat-datepicker>
  </mat-form-field>
  <mat-form-field class="w20" appearance="outline" *ngIf="exibirFiltroData">
    <mat-label>Data Final</mat-label>
    <input
      id="dataFinal"
      matInput
      [matDatepicker]="picker2"
      [(ngModel)]="dataFinal"
      (input)="formatarData($event)"
    />
    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
    <mat-datepicker #picker2></mat-datepicker>
  </mat-form-field>
  <button mat-button class="btnReturn" type="button" (click)="filtrar()" [disabled]="habilitaBotaoFiltrar()">
    <mat-icon>search</mat-icon>Filtrar
  </button>
</div>
